/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehaviorResponse } from '../../models/behavior-response';
import { ClickParams } from '../../models/click-params';

export interface RecordClick$Params {
      body: ClickParams
}

export function recordClick(http: HttpClient, rootUrl: string, params: RecordClick$Params, context?: HttpContext): Observable<StrictHttpResponse<BehaviorResponse>> {
  const rb = new RequestBuilder(rootUrl, recordClick.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BehaviorResponse>;
    })
  );
}

recordClick.PATH = '/api/behavior/click';
